export const GET_CONTRACT_SUBJECTS_QUERY = `
  query GetContractSubjects($where: contract_subjects_bool_exp = {}) {
    contract_subjects(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      status
      company_id
      is_project_based
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const GET_CONTRACT_SUBJECT_BY_ID_QUERY = `
  query GetContractSubjectById($id: Int!) {
    contract_subjects_by_pk(id: $id) {
      id
      name
      description
      status
      is_project_based
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`; 